export default __webpack_public_path__ + "media/Objective/Objective-Super-2c4435c9177a81cd02d858a69d8f1938.woff2";